import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import UserLayout from '../../layouts/User';
import { UserLesson } from './UserLesson';
import { UserChapters } from './UserChapters';
import { UserCourse } from './UserCourse';
import { UserExam } from './UserExam';
import { UserCertificate } from './UserCertificate';
import PurchasePackage from './PurchasePackage/PurchaseCourse';

import Verify from '../../components/User/TypingDNA/Verify';
import Enroll from '../../components/User/TypingDNA/Enroll';
import PreExam from '../../components/User/TypingDNA/PreExam';
import PostExam from '../../components/User/TypingDNA/PostExam';
import { connect } from 'react-redux';
import apiCall from '../../helpers/apiCall';

/*TODO: Rename routes. Don't think we should have 'user' at start of each route*/

class User extends Component {
    render() {
        return (
            <Switch>
                <UserLayout>
                    <Route
                        exact
                        path='/user/course/:courseId/chapters/:chapterId/lesson/:lessonId'
                        component={UserLesson}
                    />
                    <Route
                        exact
                        path='/user/enroll/:courseId'
                        component={Enroll}
                    />
                    <Route
                        exact
                        path='/user/preexam/:courseId'
                        component={PreExam}
                    />
                    <Route
                        exact
                        path='/user/certificate/:courseId'
                        component={UserCertificate}
                    />
                    <Route
                        exact
                        path='/user/postexam/:courseId'
                        component={PostExam}
                    />
                    <Route exact path='/user/verify' component={Verify} />
                    <Route
                        exact
                        path='/user/exam/:courseId'
                        component={UserExam}
                    />
                    <Route
                        exact
                        path='/user/orderform'
                        component={PurchasePackage}
                    />
                    <Route
                        exact
                        path='/user/course/:courseId/chapters/'
                        component={UserChapters}
                    />
                    <Route
                        exact
                        path='/user/:packageId/courses'
                        component={UserCourse}
                    />
                </UserLayout>
            </Switch>
        );
    }
}

// const mapState = (state) => {
//     const { loggedIn } = state;
//     return { loggedIn };
// };

// export default connect(mapState, {
//     setLoggedIn: (payload) => ({
//         type: 'SET_LOGGED_IN',
//         payload,
//     }),
// })(User);

export default User;
